import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'menu-button',
  standalone: true,
  imports: [],
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuButtonComponent {
  @Input() isBusy = false;
  @Input() disabled? = false;
}
